// JWM Background Colour tour
export const BACKGROUND_COLOUR_NUDGE_ID = 'backgroundColorNudge';
